var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"press-row"},[_c('marquee',{attrs:{"always":"","reverse":_vm.reverse}},[_c('div',{staticClass:"press-row__marquee"},_vm._l((_vm.press),function(item,i){return _c('press-item',_vm._b({key:`press-${i}`,staticClass:"press-row__item"},'press-item',item,false))}),1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }